import React,{useState} from 'react'
import {
  FacebookShareButton,
  TwitterShareButton,
  EmailShareButton,
  EmailIcon,
  FacebookIcon,
  TwitterIcon,
  RedditShareButton,
  RedditIcon
} from 'react-share'
import { useClipboard } from '../../helpers/useClipboard';

import styles from "./ShareGiveaway.module.css";

const ShareGiveaway = ({link}) => {
  const { copy, copied } = useClipboard();

  // const htmlOptions = {
  //   ALLOWED_TAGS: ['a','strong'],
  //   ALLOWED_ATTR: ['target','href','rel']
  // }

  const urlify = (text) => {
    var urlRegex = /(\b(https):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    return text?.match(urlRegex, function(url) {
      return url;
    })
  }

  let shareLink = link[0].props.linkUrl;
  shareLink = shareLink;
  let shareLinkValue = urlify(shareLink) ? urlify(shareLink)[0]: shareLink;

  const handleCopy = async () => {
    console.log('Copying:', shareLinkValue);
    const result = await copy(shareLinkValue);
    console.log('Copy result:', result);
  }
  return (
    <>
      <div className={styles["share-giveaway"]} style={{"--copy-text-visibility": !copied && 'hidden'}}>
        <div className={styles["title"]}>Share This Giveaway Via</div>
        <div className={styles["share-links-container"]}>
          <FacebookShareButton url={shareLinkValue}>
            <FacebookIcon
              round
              size={48}
              iconFillColor="#fff"
              bgStyle={{ fill: '#010201' }}
            />
          </FacebookShareButton>
          <TwitterShareButton url={shareLinkValue}>
            <TwitterIcon
              round
              size={48}
              iconFillColor="#fff"
              bgStyle={{ fill: '#010201' }}
            />
          </TwitterShareButton>
          <RedditShareButton url={shareLinkValue}>
            <RedditIcon
              round
              size={48}
              iconFillColor="#fff"
              bgStyle={{ fill: '#010201' }}
            />
          </RedditShareButton>
          <EmailShareButton url={shareLinkValue}>
            <EmailIcon
              round
              size={48}
              iconFillColor="#fff"
              bgStyle={{ fill: '#010201' }}
            />
          </EmailShareButton>
        </div>
        <p>Or copy link below:</p>
        <div className={styles["share-container"]}>
          <div className={styles["link-container"]}>
            <div id='shareLink' dangerouslySetInnerHTML={{ __html: shareLink }} />
          </div>
          <button className={styles["copy"]} onClick={handleCopy}>Copy</button>
        </div>
        <div className={styles["copy-text"]}>Copied to Clipboard!</div>
      </div>
    </>
  );
}

export default ShareGiveaway
